import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Helmet } from "react-helmet-async";
import { organizationSchema, SITE_NAME, SITE_URL } from "@/lib/seo-schemas";
import { Shield, Tv, HeadphonesIcon, Zap } from "lucide-react";

const APropos = () => {
  const breadcrumbItems = [
    { label: "Accueil", href: "/" },
    { label: "À propos", href: "/a-propos" },
  ];

  return (
    <>
      <Helmet>
        <title>À propos de {SITE_NAME} | Service IPTV Premium</title>
        <meta name="description" content={`Découvrez ${SITE_NAME}, votre service IPTV premium avec +100 000 films, +25 000 séries et +16 000 chaînes TV en 4K HDR. Notre mission et nos engagements.`} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`${SITE_URL}/a-propos`} />
        <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        <Breadcrumbs items={breadcrumbItems} />

        <main className="max-w-4xl mx-auto px-4 py-16">
          <h1 className="text-3xl md:text-5xl font-black text-foreground mb-8">
            À propos de <span className="text-primary">{SITE_NAME}</span>
          </h1>

          <section className="prose prose-invert max-w-none space-y-6 text-muted-foreground leading-relaxed">
            <p className="text-lg">
              {SITE_NAME} est un service de streaming IPTV premium qui propose un accès illimité à plus de 100 000 films,
              25 000 séries et 16 000 chaînes TV en qualité 4K HDR. Notre mission est de rendre le divertissement
              accessible à tous, avec une expérience fluide et sans compromis.
            </p>

            <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Notre mission</h2>
            <p>
              Nous croyons que le divertissement de qualité ne devrait pas coûter une fortune. C'est pourquoi nous
              proposons un catalogue complet — films, séries, sport en direct — à un prix accessible, avec une
              qualité d'image irréprochable et un support client réactif 7 jours sur 7.
            </p>

            <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Nos engagements</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 not-prose">
              {[
                { icon: Tv, title: "Qualité 4K HDR", desc: "Une image cristalline sur tous vos écrans, du smartphone à la Smart TV." },
                { icon: Zap, title: "Streaming fluide", desc: "Serveurs optimisés pour un streaming sans lag ni buffering." },
                { icon: HeadphonesIcon, title: "Support 7j/7", desc: "Notre équipe est disponible pour vous aider à tout moment par email." },
                { icon: Shield, title: "Paiement sécurisé", desc: "Transactions 100% sécurisées via Stripe avec garantie satisfait." },
              ].map((item) => (
                <div key={item.title} className="p-5 rounded-xl bg-card border border-border/50">
                  <item.icon className="w-8 h-8 text-primary mb-3" />
                  <h3 className="font-bold text-foreground mb-1">{item.title}</h3>
                  <p className="text-sm text-muted-foreground">{item.desc}</p>
                </div>
              ))}
            </div>

            <h2 className="text-2xl font-bold text-foreground mt-12 mb-4">Contact</h2>
            <p>
              Pour toute question, notre équipe est joignable à{" "}
              <a href="mailto:contact@roidustreaming.fr" className="text-primary hover:underline">
                contact@roidustreaming.fr
              </a>.
            </p>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default APropos;
